<template>
    <div class="container mx-auto px-2 py-4">
        <h1>Registrierung<br/>zum Online-Heizkostenvergleich des BDEW</h1>
        <div class="flex mb-10">
            <div class="w-full md:w-6/12">
                Sie haben noch keine Zugangsdaten zum Online-Heizkostenvergleich? Dann registrieren Sie sich bitte. Nach der kostenfreien Registrierung und der Teilnahme / Ansicht des Online-Webinars können Sie das Tool nutzen.
            </div>
            <div class="w-full md:w-6/12 justify-center flex">
                <div style="width: 270px;">
                    <div class="bg-primary-default relative" style="width: 100%; height: 0; padding-bottom: 66%;">
                        <div class="absolute left-0 top-0 w-full h-full justify-center flex flex-col text-center">
                            <Icon :name="'play'" :height="8" :width="8" class="text-white mx-auto"/>
                            <a href="https://bdew-webinare.webex.com/recordingservice/sites/bdew-webinare/recording/2851dbdf85ab4260ba620f3d4839712b/playback" target="_blank" class="inline-block text-white underline font-bold mt-2 text-sm">Letztes Webinar ansehen</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form @submit.prevent="onRegister" novalidate class="box">
            <h2>Registrierung zum Online-Heizkostenvergleich</h2>
                <div class="flex flex-wrap -mx-4">
                    <base-input v-model.trim="surname"
                                :id-prefix="'surname'"
                                class="w-full md:w-6/12 px-4"
                                name="surname"
                                :validations="[{ condition: v$.surname.required &&  v$.surname.$error && surname == '',text:'Bitte tragen Sie Ihren Vornamen ein!'}]"
                                ref="register-surname"
                                :type="'text'" label="default.surname" required/>

                    <base-input v-model.trim="name"
                                :id-prefix="'name'"
                                class="w-full md:w-6/12 px-4"
                                name="name"
                                :validations="[{ condition: v$.name.required &&  v$.name.$error && name == '',text:'Bitte tragen Sie Ihren Nachnamen ein!'}]"
                                ref="register-name"
                                :type="'text'" label="default.lastname" required/>

                    <base-input v-model.trim="company"
                                :id-prefix="'company'"
                                class="w-full md:w-6/12 px-4"
                                name="company"
                                :validations="[{ condition: v$.company.required &&  v$.company.$error && company == '',text:'Bitte tragen Sie Ihre Firma ein!'}]"
                                ref="register-company"
                                :type="'text'" label="default.company" required/>

                    <base-input v-model.trim="registerEmail"
                                :id-prefix="'register'"
                                class="w-full md:w-6/12 px-4"
                                name="email"
                                :validations="[{ condition: v$.registerEmail.required &&  v$.registerEmail.$error && registerEmail == '',text:'Bitte trage deine E-Mail Adresse ein!'},{ condition: v$.registerEmail.email.$invalid &&  v$.registerEmail.$error ,text:'Bitte trage deine korrekte E-Mail Adresse ein!'}]"
                                ref="register-email"
                                :type="'text'" label="default.email" required/>

                    <base-input v-model.trim="password"
                                :id-prefix="''"
                                class="w-full md:w-6/12 px-4"
                                name="password"
                                :validations="[{ condition: v$.password.required &&  v$.password.$error && password == '',text:'Bitte tragen Sie Ihr Passwort ein!'},{ condition: v$.password.minLength.$invalid &&  v$.password.$error ,text:'Mindestlänge 6 Zeichen'}]"
                                :type="'password'" label="default.password" required/>

                    <base-input v-model.trim="confirmPassword"
                                :id-prefix="'register'"
                                class="w-full md:w-6/12 px-4"
                                name="password_confirm"
                                :validations="[{ condition: v$.confirmPassword.$error ,text:'Bitte wiederholen Sie Ihr Passwort!'}]"
                                ref="register-password"
                                :type="'password'" label="default.password_confirm" required/>
                </div>
            <div class="text-sm w-full float-left mb-4">
                *Pflichtfelder
            </div>
                <div class="w-full float-left mb-4">

                    <base-checkbox
                        :id-prefix="'webinar'"
                        name="webinar"
                        :validations="[{ condition: !v$.webinar.$model && submitted, text:'Bitte bestätigen!'}]"
                        v-model:checked="webinar"
                    >
                        Ich habe das <a href="https://bdew-webinare.webex.com/recordingservice/sites/bdew-webinare/recording/2851dbdf85ab4260ba620f3d4839712b/playback" target="_blank" class="underline">Webinar</a> zum Online Heizkostenvergleich des BDEW vollständig angesehen und verstanden.
                    </base-checkbox>

                    <base-checkbox
                        :id-prefix="'register'"
                        name="privacy"
                        :validations="[{ condition: !v$.privacy.$model && submitted, text:'Bitte bestätigen!'}]"
                        v-model:checked="privacy"
                    >
                        Ich stimme den <router-link to="privacy" class="underline">Datenschutzhinweisen</router-link> und den <a href="https://www.bdew.de/rechtliches/" target="_blank" class="underline">rechtlichen Hinweisen</a> zu
                    </base-checkbox>
                </div>

                <base-button type="submit" :loading="axiosCall" class="button-min-width">
                    kostenfrei Registrieren
                </base-button>
        </form>

        <div class="text-sm my-10">Ihre Zugangsdaten werden an die oben genannte E-Mail-Adresse gesendet.<br>
            Die Zugangsdaten sind nur für Sie persönlich und dürfen nicht weitergegeben oder anderen Personen zugänglich gemacht werden.</div>
    </div>
</template>

<script>

import useVuelidate from '@vuelidate/core'
import {isChecked} from '@/utils/validators'
import {email, required, sameAs, minLength, requiredUnless} from '@vuelidate/validators'
import {ref, computed, getCurrentInstance} from 'vue'
import {useRouter} from 'vue-router'
import {useStore} from "vuex";


export default {

    setup(props) {
        const name = ref('');
        const surname = ref('');
        const registerEmail = ref('');
        const company = ref('');
        const password = ref('');
        const confirmPassword = ref('');
        const privacy = ref(false);
        const webinar = ref(false);
        const submitted = ref(false);
        const router = useRouter();
        const store = useStore();
        const axiosCall = ref(false);
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        const rules = computed(() => ({

            registerEmail: {required, email},
            name: {required},
            surname: {required},
            company: {required},
            privacy: {isChecked},
            webinar: {isChecked},
            password: {
                required,
                minLength: minLength(6)
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs(password.value),
            }
        }))

        const v$ = useVuelidate(rules, {name, surname, company, registerEmail, password, confirmPassword, privacy, webinar})

        const onRegister = () => {

            submitted.value = true
            v$.value.$touch()

            if (v$.value.$error || !privacy.value) return

            axiosCall.value = true

            const registerData = {
                name: name.value,
                email: registerEmail.value,
                surname: surname.value,
                company: company.value,
                password: password.value,
                password_confirmation: confirmPassword.value,
                privacy: privacy.value ? '1' : ''
            }

            store.dispatch('Customer/register', registerData)
                .then(() => {
                    emitter.emit("flash-message", {
                        text: 'Willkommen!',
                        type: 'success'
                    })
                    axiosCall.value = false
                    router.push('/verify');
                })
                .catch(err => {
                    emitter.emit("flash-message", {
                        text: 'error on register',
                        type: 'error'
                    })
                    axiosCall.value = false;
                    emitter.emit("flash-message", {
                        text: err.response.data.message,
                        type: 'error'
                    })
                })

        }

        return {
            name,
            surname,
            registerEmail,
            company,
            password,
            confirmPassword,
            privacy,
            webinar,
            onRegister,
            v$,
            axiosCall,
            submitted
        }
    }
}
</script>
